import { useEffect, useState } from 'react';
import styles from '../../pages/v2/Layout.module.css';
import homeStyles from '../../pages/v2/home.module.css';
import errorStyles from '../../pages/404.module.css';
import Button from '../Button/CustomButton';
import Title from '../Title/title';

import Image from 'next/image';
import billzyLogoSVG from '../../public/billzy_logo.png';
import defaultError from '../../public/DefaultError.svg';

export default function AccessDenied() {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => (prev > 0 ? prev - 1 : prev));
        }, 1000);

        const timer = setTimeout(() => {
            goBackToHome();
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timer);
        };
    }, []);

    const goBackToHome = () => {
        window.location.href = '/home';
    };

    return (
        <div className={styles.pageContainer}>
            <Title value="Access Denied | Billzy" />
            <div className={styles.pageLayout}>
                <div className={homeStyles.home_page_header}>
                    <div className="logo">
                        <Image
                            src={billzyLogoSVG}
                            className="billzy_logo"
                            alt="Billzy Logo"
                        />
                    </div>
                </div>
                <div className={errorStyles.pageContainer}>
                    <div className={errorStyles.pageHeading}>Access Denied</div>
                    <div className={errorStyles.metaHeading}>
                        You don't have permission to view this page. Please log
                        in to continue.
                    </div>
                    <Image
                        src={defaultError}
                        alt="Access Denied Icon"
                        style={{
                            marginTop: '50px',
                        }}
                    />
                    <div className={errorStyles.redirectMessage}>
                        Redirecting to home in <strong>{countdown}s</strong>
                    </div>
                    <div className={errorStyles.footerButton}>
                        <Button
                            text="Back to Home"
                            click={goBackToHome}
                            className={`${styles.cgbtn} ${styles.cgLargebtn} ${styles.cgLargebtnDestop}`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
